import { useLocalization } from "@fluent/react";
import { formatCentsAsDollars } from "@lending/utils/formatters";
import { getProductName, getStatusLabel, useApplicationHref } from "./applicationHelpers";
import { ProductIcon } from "./ProductIcon";
import { StatusTag } from "./StatusTag";
import styles from "../LoanPortalDashboard.module.css";
import { needsAttention } from "../portalApplicationStatus";
import type { LoanPortalApplication } from "../types";

/** A card in the "Your applications" grid. */
export function ApplicationCard({ application }: { application: LoanPortalApplication }) {
  const { l10n } = useLocalization();
  const href = useApplicationHref(application);
  const cardContent = (
    <>
      <div className={styles.applicationCardTop}>
        <div className={styles.applicationCardHeading}>
          <div className={styles.applicationCardIcon}>
            <ProductIcon productType={application.productType} />
          </div>
          <div className={styles.applicationCardHeadingText}>
            <div className={styles.applicationCardName}>
              {getProductName(l10n, application.productType)}
            </div>
            <div className={styles.applicationCardId}>
              {l10n.getString(
                "loan-portal-application-id",
                { id: application.displayId },
                `ID #${application.displayId}`
              )}
            </div>
          </div>
        </div>
        <StatusTag l10n={l10n} application={application} />
      </div>
      <div className={styles.applicationCardAmount}>
        {application.amountCents !== null && application.amountCents !== undefined
          ? formatCentsAsDollars(application.amountCents)
          : l10n.getString("loan-portal-requested-amount-not-available", null, "$ ---")}
      </div>
      <div className={styles.applicationCardStatus}>
        {getStatusLabel(l10n, application.loanPortalStatus)}
      </div>
    </>
  );

  if (!needsAttention(application)) {
    return <div className={styles.applicationCard}>{cardContent}</div>;
  }

  return (
    <a className={styles.applicationCard} href={href}>
      {cardContent}
    </a>
  );
}
